import dayjs from 'dayjs';
import { timezoneList } from '../assets/timezone';
import { getTime, getTimeWithTZ } from './getTime';
import { capitalizeFirstLetter } from './textHelpers';
import { IConsultation } from '../store/types';

function getDateForInvite(item: IConsultation, fallback: Date) {
  const datePart = item.date?.slice(0, 10);
  if (datePart && /^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
    return dayjs(datePart);
  }

  const parsed = dayjs(item.date);
  return parsed.isValid() ? parsed : dayjs(fallback);
}

type BuildInviteOptions = {
  specializationText: string;
  /** ФИО из userData, если в item.psychologist пусто */
  psychNameFromUserFallback: string;
  /** full_name клиента/группы (как в карточке) */
  clientFullName?: string;
  /** Из формы: подпись часового пояса (если не сохранили) */
  timezoneLabelOverride?: string;
  /** Из формы: ссылка */
  linkOverride?: string;
};

/**
 * Текст приглашения в буфер (карточка, календарь, форма) — единая разметка.
 */
export function buildConsultationInviteText(
  item: IConsultation,
  {
    specializationText,
    psychNameFromUserFallback,
    clientFullName,
    timezoneLabelOverride,
    linkOverride,
  }: BuildInviteOptions,
): string {
  const p = item.psychologist;
  const psychName =
    [p?.last_name, p?.first_name, p?.middle_name].filter(Boolean).join(' ').trim() || psychNameFromUserFallback;

  const tzLabel = timezoneLabelOverride ?? item.client_timezone;
  const tzOff = timezoneList.find((el) => el.name === tzLabel)?.offset;
  const start = new Date(item.datetime_start);
  const end = new Date(item.datetime_end);
  const isGroup = Boolean(item.is_group);
  const dateForLine = getDateForInvite(item, start);

  const groupName =
    (clientFullName ?? item.client_full_name ?? '')
      .split('-')[0]
      ?.trim() || 'Группа';

  const timeRange = isGroup
    ? `${getTime(start)}–${getTime(end)}`
    : `${getTimeWithTZ(start, Number(tzOff))}–${getTimeWithTZ(end, Number(tzOff))}`;

  const whoBlock = isGroup
    ? `Группа: ${groupName}
${specializationText}: ${psychName}`
    : `${specializationText}: ${psychName}`;

  const link = linkOverride ?? item.link;

  return `У Вас назначена встреча в ZiNGiZi.
${whoBlock}
${capitalizeFirstLetter(dateForLine.format('dddd'))}, ${dateForLine.format('DD MMMM')} · ${timeRange}
Часовой пояс: ${tzLabel}
Ссылка на видеовстречу: ${link}`;
}
